import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="border-t-2 border-[#1A1D1E] bg-[#1A1D1E] text-[#FAF9F6]">
    <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 py-14 md:flex-row md:items-end md:justify-between md:px-12">
      <div>
        <p className="flex items-center gap-3 font-display text-3xl font-semibold tracking-tight">
          <img
            src="/app-icon.jpg"
            alt="TriviaPro app icon"
            className="h-11 w-11 rounded-[12px] border-2 border-[#FAF9F6]/20 object-cover"
          />
          Trivia
          <span className="rounded-full bg-[#FFC837] px-2 py-0.5 align-middle text-xs font-bold uppercase tracking-widest text-[#1A1D1E]">
            Pro
          </span>
        </p>
        <p className="mt-3 max-w-sm text-sm leading-relaxed text-[#FAF9F6]/60">
          Fair-play family trivia for kids and adults. Made for families who
          play fair – mostly.
        </p>
      </div>
      <div className="flex flex-col gap-3 text-sm font-bold">
        <div className="flex gap-6">
          <Link to="/" data-testid="footer-home-link" className="transition-colors duration-200 hover:text-[#1FBCA2] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 rounded">
            Home
          </Link>
          <Link to="/about" data-testid="footer-about-link" className="transition-colors duration-200 hover:text-[#1FBCA2] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 rounded">
            About TriviaLabs
          </Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors duration-200 hover:text-[#1FBCA2] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 rounded">
            Privacy Policy
          </Link>
        </div>
        <a
          href="mailto:info@trivialabs.org"
          data-testid="footer-contact-email"
          className="inline-flex items-center gap-2 text-[#FAF9F6]/70 transition-colors duration-200 hover:text-[#FFC837] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 rounded"
        >
          <Mail className="h-4 w-4" />
          info@trivialabs.org
        </a>
      </div>
    </div>
    <div className="border-t border-[#FAF9F6]/10 py-5 text-center text-xs font-semibold text-[#FAF9F6]/40">
      © 2026 TriviaPro. All rights reserved.
    </div>
  </footer>
);
